import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionsSection = ({ 
  onAddContact = () => {},
  onRandomContact = () => {},
  onSendBirthdayWishes = () => {},
  todaysBirthdays = 0
}) => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'add-contact',
      title: 'Add Contact',
      description: 'Add new contact to your list',
      icon: 'UserPlus',
      color: 'bg-primary',
      textColor: 'text-primary-foreground',
      onClick: () => {
        onAddContact();
        navigate('/add-edit-contact');
      }
    },
    {
      id: 'random-contact',
      title: 'Random Contact',
      description: 'Connect with someone randomly',
      icon: 'Shuffle',
      color: 'bg-accent',
      textColor: 'text-accent-foreground',
      onClick: () => {
        onRandomContact();
        navigate('/random-contact');
      }
    },
    {
      id: 'birthday-wishes',
      title: 'Birthday Wishes',
      description: todaysBirthdays > 0 ? `${todaysBirthdays} birthday${todaysBirthdays > 1 ? 's' : ''} today` : 'Send birthday messages',
      icon: 'Gift',
      color: 'bg-success',
      textColor: 'text-success-foreground',
      badge: todaysBirthdays > 0 ? todaysBirthdays : null,
      onClick: () => {
        onSendBirthdayWishes();
        navigate('/birthday-calendar');
      }
    }
  ];

  return (
    <div className="bg-surface rounded-lg border border-border shadow-card p-4 lg:p-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Zap" size={20} className="text-primary" />
        <h2 className="text-lg font-semibold text-text-primary">Quick Actions</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={action?.onClick}
            className="relative p-4 rounded-lg border border-border bg-background hover:bg-muted transition-micro hover-lift text-left group"
          >
            <div className="flex items-start space-x-3">
              <div className={`w-12 h-12 rounded-lg ${action?.color} flex items-center justify-center flex-shrink-0 group-hover:scale-105 transition-micro`}>
                <Icon name={action?.icon} size={24} className={action?.textColor} />
              </div>
              
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-text-primary group-hover:text-primary transition-micro">
                  {action?.title}
                </h3>
                <p className="text-sm text-text-secondary mt-1">
                  {action?.description}
                </p>
              </div>
            </div>

            {action?.badge && (
              <div className="absolute -top-2 -right-2 w-6 h-6 bg-error text-error-foreground text-xs rounded-full flex items-center justify-center">
                {action?.badge > 99 ? '99+' : action?.badge}
              </div>
            )}

            <Icon 
              name="ArrowRight" 
              size={16} 
              className="absolute top-4 right-4 text-text-secondary group-hover:text-primary group-hover:translate-x-1 transition-micro" 
            />
          </button>
        ))}
      </div>
      {/* Additional Quick Actions */}
      <div className="grid grid-cols-2 gap-3 mt-4">
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate('/message-templates')}
          iconName="MessageSquare"
          iconPosition="left"
          className="justify-start"
        >
          Message Templates
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate('/contact-list')}
          iconName="Users"
          iconPosition="left"
          className="justify-start"
        >
          View All Contacts
        </Button>
      </div>
    </div>
  );
};

export default QuickActionsSection;